import { IconButton, Tooltip } from "@material-ui/core";
import { createStyles, WithStyles, withStyles } from "@material-ui/core/styles";
import { format } from "date-fns";
import * as React from "react";

import { RelodeTheme } from "../";
import { TrashIcon } from "../../assets/icons";
import { AttachmentLink } from "./attachmentLink";
import { Attachment } from "./types";

const styles = (theme: RelodeTheme) =>
    createStyles({
        root: {},
        row: {
            display: "flex",
            flexDirection: "row",
            marginBottom: theme.spacing(1),
            justifyContent: "space-between",
            alignItems: "center",
        },
    });

interface OwnProps {
    id?: string;
    attachments: Attachment[];
    handleChange?: (attachments: Attachment[]) => void;
    disableDateAndFileSizeDisplay?: boolean;
}

interface Props extends OwnProps, WithStyles<typeof styles> {}

export const AttachmentLinkCollection = withStyles(styles)(
    class extends React.Component<Props> {
        handleRemove = (i: number) => {
            const { attachments } = this.props;
            const tmpAttachments = [...attachments];
            tmpAttachments.splice(i, 1);
            this.props.handleChange(tmpAttachments);
        };

        render() {
            const { id, classes, attachments = [], disableDateAndFileSizeDisplay } = this.props;

            return (
                <div
                    className={classes.root}
                    id={`${id}AttachmentLinkCollectionWrapper`}
                >
                    {attachments &&
                        attachments.map((att: Attachment, i: number) => (
                            <div className={classes.row} key={i}>
                                <AttachmentLink
                                    baseId={`${id}AttachmentLinkCollectionLink${i}`}
                                    key={i}
                                    icon={true}
                                    url={att.fileUri}
                                    playMediaInNewWindow={true}
                                    label={att.fileName}
                                    type={att.contentType}
                                    date={disableDateAndFileSizeDisplay ? null : format(att.createTimestamp, "P p")}
                                    highlightType="internal"
                                    friendlyAttachmentSize={
                                        disableDateAndFileSizeDisplay ? null : att.friendlyFileSize
                                    }
                                />
                                {this.props.handleChange ? (
                                    <Tooltip
                                        placement="bottom-start"
                                        title={`remove ${att.fileName}`}
                                    >
                                        <IconButton
                                            id={`${id}AttachmentLinkCollectionRemoveLink${i}Button`}
                                            color="primary"
                                            onClick={() => this.handleRemove(i)}
                                            aria-label="remove attachment"
                                        >
                                            <TrashIcon />
                                        </IconButton>
                                    </Tooltip>
                                ) : null}
                            </div>
                        ))}
                </div>
            );
        }
    }
);
